import React, { useState } from 'react'
import { Link } from 'react-router-dom'
import axios from 'axios'
import FormField from '../../utils/FormField'

export default function ForgotPassword() {
  const [state, setState] = useState({})
  const [submitting, setSubmitting] = useState(false)
  const [sent, setSent] = useState(false)
  const [error, setError] = useState(null)

  const onChange = (event) => {
    const { name, value } = event.target
    setState((prevState) => ({ ...prevState, [name]: value }))
  }

  const onSubmit = async (event) => {
    event.preventDefault()
    setSubmitting(true)
    setError(null)
    try {
      await axios.post('/api/v1/auth/forgot-password', { email: state.email })
      setSent(true)
    } catch {
      setError('Could not send the reset email. Please try again.')
    } finally {
      setSubmitting(false)
    }
  }

  return (
    <div className="min-h-screen bg-gray-50 flex flex-col justify-center py-12 px-6 lg:px-8">
      <div className="mt-8 mx-auto w-full max-w-lg">
        <div className="bg-white pb-4 pt-2 shadow rounded-lg px-5 lg:pb-8 lg:pt-4 lg:px-10">
          <img src="/brand/eadin-logo-full.png" alt="Eadin" className="h-14 w-auto mx-auto mb-4" />
          {sent ? (
            <>
              <p className="text-sm text-gray-700">
                If an Eadin account uses that email address, a password reset link is on its way. The link expires in
                30 minutes.
              </p>
              <Link to="/signin" className="mt-6 inline-block text-sm text-gray-600 underline">
                Back to sign in
              </Link>
            </>
          ) : (
            <>
              <h1 className="text-base font-medium text-gray-900">Reset your password</h1>
              <p className="mt-1 mb-6 text-sm text-gray-500">
                Enter your Eadin email address and we'll email you a link to choose a new password.
              </p>
              {error ? <p className="mb-4 text-sm text-red-600">{error}</p> : null}
              <form className="space-y-6" onSubmit={onSubmit}>
                <FormField
                  label="Email Address"
                  field="email"
                  type="email"
                  onChange={onChange}
                  autoComplete="username"
                  state={state}
                />
                <div className="flex items-center gap-4">
                  <button
                    type="submit"
                    disabled={submitting}
                    className="bg-[#111] hover:bg-black text-white px-4 py-2 rounded-md text-sm disabled:opacity-50"
                  >
                    {submitting ? 'Sending…' : 'Send reset link'}
                  </button>
                  <Link to="/signin" className="text-sm text-gray-600 underline">
                    Back to sign in
                  </Link>
                </div>
              </form>
            </>
          )}
        </div>
      </div>
    </div>
  )
}
